const ThankYouMessage = () => {
    return (
        <div className="contact-thank-you text-center">
            <div className="contact-thank-you-icon">
                <i className="fas fa-check"></i>
            </div>
            <span className="sub-title">Message received</span>
            <h3 className="title">Thank you for reaching out.</h3>
            <p>
                Our application engineer will review your needs and reach back out to you soon.
            </p>
        </div>
    )
}

export default ThankYouMessage
